package horcrux.common.types

import arrow.core.Either
import arrow.core.raise.either
import horcrux.common.utils.raiseError
import io.ktor.http.Headers

sealed interface DocumentTypeIdentifier

data object DocumentContainer : DocumentTypeIdentifier

enum class MimeType(
    val value: String
) : DocumentTypeIdentifier {
    APPLICATION_JSON("application/json"),
    APPLICATION_OCTET_STREAM("application/octet-stream"),
    APPLICATION_PDF("application/pdf"),
    CSS("text/css"),
    CSV("text/csv"),
    ICS("text/calendar"),
    IMAGE_JPEG("image/jpeg"),
    IMAGE_PNG("image/png"),
    IMAGE_SVG("image/svg+xml"),
    IMAGE_WEBP("image/webp"),
    IMAGE_GIF("image/gif"),
    IMAGE_ICO("image/vnd.microsoft.icon"),
    IMAGE_TIFF("image/tiff"),
    IMAGE_BMP("image/bmp"),
    TEXT_CSS("text/css"),
    JAVASCRIPT("text/javascript"),
    TEXT_HTML("text/html"),
    TEXT_PLAIN("text/plain"),
    VIDEO_MP4("video/mp4"),
    XML("application/xml");

    companion object {
        private val mimeTypeByValue: Map<String, MimeType> = entries.associateBy { it.value }
        private const val HEADER_KEY: String = "Content-Type"
        operator fun invoke(value: String): Either<Throwable, MimeType> = either {
            mimeTypeByValue[value] ?: raiseError("$value is invalid MimeType")
        }

        operator fun invoke(headers: Headers): Either<Throwable, MimeType> = either {
            headers[HEADER_KEY]?.let { invoke(it).bind() } ?: raiseError("Headers does not contain key $HEADER_KEY")
        }
    }
}
